// A tiny external store tracking whether a pairing code is currently displayed.
// The in-memory code must survive a non-forced update, so the update prompt
// needs to know this without holding the code itself.

import { useEffect, useState } from 'react';

let active = false;
const listeners = new Set<(value: boolean) => void>();

function emit(): void {
  for (const listener of listeners) listener(active);
}

/** Mark a pairing code as displayed (or cleared). */
export function setPairingCodeActive(value: boolean): void {
  if (active === value) return;
  active = value;
  emit();
}

/** Whether a pairing code is currently on screen. */
export function isPairingCodeActive(): boolean {
  return active;
}

/** Subscribe to changes in the pairing-code visibility. */
export function usePairingCodeGuard(): boolean {
  const [value, setValue] = useState(active);
  useEffect(() => {
    const listener = (next: boolean): void => setValue(next);
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  }, []);
  return value;
}
